import { render, staticRenderFns } from "./ConnectCard.vue?vue&type=template&id=99792d82&scoped=true&"
import script from "./ConnectCard.vue?vue&type=script&lang=js&"
export * from "./ConnectCard.vue?vue&type=script&lang=js&"
import style0 from "./ConnectCard.vue?vue&type=style&index=0&id=99792d82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99792d82",
  null
  
)

export default component.exports